import React from 'react';
import { RecoilRoot } from 'recoil';
import { GatsbyBrowser } from 'gatsby';
import App from './src/App';
import Page from './src/Page';
import { SupportedLanguages } from './src/models/languages';

import 'firebase/analytics';
import 'firebase/database';
import 'katex/dist/katex.min.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import './src/prism-theme.css';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return (
    <RecoilRoot>
      <App>{element}</App>
    </RecoilRoot>
  );
};

export const wrapPageElement: GatsbyBrowser<unknown, { lang: SupportedLanguages }>['wrapPageElement'] = ({
  element,
  props,
}) => {
  return <Page {...props}>{element}</Page>;
};
